import { useLocation, Navigate } from "@/lib/router-compat";

/**
 * Strips trailing slashes from URLs to prevent 404s.
 * GSC data shows many high-traffic URLs with trailing slashes
 * that don't match our routes (React Router v6 doesn't auto-strip them).
 */
const TrailingSlashRedirect = () => {
  const { pathname, search, hash } = useLocation();

  if (pathname !== "/" && pathname.endsWith("/")) {
    return <Navigate to={pathname.slice(0, -1) + search + hash} replace />;
  }

  return null;
};

export default TrailingSlashRedirect;
